// Bernie
import { AnalyticsStore, codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import { UiStore } from 'stores';

// Utils
import analyticsUtil from '../util/AnalyticsUtil';
import { pageNames } from '../data/page-names';

class SearchController implements Controller {
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "search-page" */ '../views/search-page'));

  public pageId = pageNames.search;

  public path = '/:localeName/search';
  public exact = true;

  public routeName = 'search';

  public fetch(options: FetchOptions) {
    const { stores, request } = options;

    const analyticsStore: AnalyticsStore = stores?.get<AnalyticsStore>('analytics');

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, request.context);

    return Promise.resolve(Result.ok());
  }

  public fetchPageData() {
    const pageData: PageData = {
      title: 'Search Widget',
    };

    return Promise.resolve(pageData);
  }
}

export { SearchController };
